import React, { Component } from 'react'

import { DatePicker } from '../../utilites'

class ModalOutboxOperation extends Component {

  render() {
    return (
      <div>
        <fieldset>
          <div className="d-flex flex-start align-baseline">
            <p className="m-r-spacer"><big>Предыдущий №70 от 09.12.2020, Воробьёва Наталья</big></p>
            <span className="label">МН16</span>
          </div>
        </fieldset>
        <fieldset>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="#">Основание</label>
                <div className="form-element-data">
                  <select className="input">
                    <option>Выберите…</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="">Сумма, BYN</label>
                <div className="form-element-data number">
                  <input className="input" type="text" name="" id="" />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="#">Принятно</label>
                <div className="form-element-data date">
                  <DatePicker />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="">Номер документа</label>
                <div className="form-element-data">
                  <input className="input" type="text" name="" id="" />
                </div>
              </div>
            </div>
          </div>
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Приложение</label>
            <div className="form-element-data textarea">
              <textarea className="input" rows="4" cols="10" name="#" id="#"></textarea>
            </div>
          </div>
        </fieldset>
      </div>
    )
  }
}

export default ModalOutboxOperation
